<app-main-header></app-main-header>
<main class="post-login-main">
  <router-outlet></router-outlet>
</main>